// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1-Bc5","left":"styles_left__2EdYj"};